export default {
	methods: {
		invalidFeedback(field) { return this.error && this.error[field] ? this.error[field][0] : "there's an err here"},
		checkState(field){ return this.error ? ( this.error[field] ? false : null ) : null },
	}
};
